import { forwardRef, type TextareaHTMLAttributes } from 'react'

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  error?: string
  hint?: string
  // EP-95: `className` targets the OUTER form-control wrapper (parity with
  // Select/Input — default 'w-full'); `textareaClassName` targets the element.
  textareaClassName?: string
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className = '', textareaClassName = '', label, error, hint, id, required, ...props }, ref) => {
    const textareaId = id || props.name

    return (
      <div className={`form-control ${className || 'w-full'}`}>
        {label && (
          <label className="label whitespace-normal" htmlFor={textareaId}>
            <span className="label-text">
              {label}
              {required && <span className="text-error ml-0.5" aria-hidden="true">*</span>}
            </span>
          </label>
        )}
        <textarea
          ref={ref}
          id={textareaId}
          required={required}
          className={`textarea textarea-bordered w-full ${error ? 'textarea-error' : ''} ${textareaClassName}`}
          {...props}
        />
        {(error || hint) && (
          <label className="label whitespace-normal">
            <span className={`label-text-alt ${error ? 'text-error' : ''}`}>
              {error || hint}
            </span>
          </label>
        )}
      </div>
    )
  }
)

Textarea.displayName = 'Textarea'
